import React from "react";

import { Props } from "./types";

function ListIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 56 32.667">
      <rect width="56" height="14" rx="2" />
      <rect width="56" height="14" rx="2" transform="translate(0 18.667)" />
    </svg>
  );
}

export { ListIcon };
